import { mapProduct } from '../composables'
import { PRIZE_MODAL_PRODUCTS_COUNT } from '../constants'

export const filterInStockProducts = (products = []) =>
  products.filter((product) => product?.inStock === true)

export const mapProductsForCards = (products) =>
  products.map((item) => ({
    ...mapProduct(item),
    attributes: null,
  }))

export const hasPrizeProductsLink = (productsLink) =>
  typeof productsLink === 'string' && productsLink.trim() !== ''

/**
 * Показывать/грузить подборку: есть SKU или можно обогатить по productsLink.
 */
export const shouldShowPrizeModalProducts = ({
  products = [],
  productsLink = '',
  shouldEnrichProducts = false,
} = {}) => {
  if (products?.length) return true

  return shouldEnrichProducts && hasPrizeProductsLink(productsLink)
}

export const createSkeletonSlots = (count = PRIZE_MODAL_PRODUCTS_COUNT) =>
  Array.from({ length: count }, () => ({
    product: null,
    skeleton: true,
  }))

export const buildSlotsFromProducts = (
  products,
  count = PRIZE_MODAL_PRODUCTS_COUNT,
) => {
  const slots = []

  for (let index = 0; index < count; index += 1) {
    const product = products[index]

    if (product != null) {
      slots.push({ product, skeleton: false })
    } else {
      slots.push({ product: null, skeleton: true })
    }
  }

  return slots
}

export const mergeProductsIntoSkeletonSlots = (slots, additionalProducts) => {
  const existingIds = new Set(
    slots
      .filter((slot) => slot.product != null)
      .map((slot) => slot.product.itemId),
  )

  let additionalIndex = 0

  return slots.map((slot) => {
    if (!slot.skeleton || slot.product != null) return slot

    while (additionalIndex < additionalProducts.length) {
      const product = additionalProducts[additionalIndex]
      additionalIndex += 1

      if (existingIds.has(product.itemId)) continue

      existingIds.add(product.itemId)

      return { product, skeleton: false }
    }

    return slot
  })
}

export const clearRemainingSkeletonSlots = (slots) =>
  slots.map((slot) =>
    slot.skeleton && slot.product == null
      ? { product: null, skeleton: false }
      : slot,
  )
